



















import { Component, Mixins, Prop, Emit } from "vue-property-decorator";
import { Office } from "@/model/office";
import { Billing } from "@/model/agreement/billing";
import UtilMixin from "@/mixins/utilMixin";
import OfficeInfo from "@/components/contractreception/OfficeInfo.vue";

@Component({
  components: {
    OfficeInfo,
  },
})
export default class BillingInfoDetailNavigation extends Mixins(UtilMixin) {
  @Prop({ default: false }) value!: boolean;

  @Prop({}) office!: Office;
  @Prop({}) billing!: Billing;

  @Emit()
  private input(newValue: boolean): boolean {
    return newValue;
  }

  private get Drawer(): boolean {
    return this.value;
  }

  private set Drawer(newValue: boolean) {
    this.input(newValue);
  }
}
